import { render, staticRenderFns } from "./picker.vue?vue&type=template&id=2fcc041a&scoped=true&"
import script from "./picker.vue?vue&type=script&lang=js&"
export * from "./picker.vue?vue&type=script&lang=js&"
import style0 from "./picker.vue?vue&type=style&index=0&id=2fcc041a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc041a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcc041a')) {
      api.createRecord('2fcc041a', component.options)
    } else {
      api.reload('2fcc041a', component.options)
    }
    module.hot.accept("./picker.vue?vue&type=template&id=2fcc041a&scoped=true&", function () {
      api.rerender('2fcc041a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/m-picker/picker.vue"
export default component.exports